var _mask, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCirclePlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle--plant_svg__a",
    height: 14,
    maskUnits: "userSpaceOnUse",
    width: 14,
    x: 4,
    y: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h14v14H4z",
    fill: "#000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.25,
    stroke: "#000",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle--plant_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 16.25c-.165 0-.304-.056-.416-.168s-.167-.25-.167-.415v-4.07c-.623 0-1.22-.118-1.794-.356A4.634 4.634 0 016.1 8.71a4.716 4.716 0 01-.35-1.794v-.584c0-.165.056-.303.168-.415a.564.564 0 01.415-.168h.584c.612 0 1.205.12 1.779.357a4.641 4.641 0 012.268 2.006c.199.36.352.743.459 1.152.049-.068.102-.134.16-.197.059-.063.122-.13.19-.197a4.642 4.642 0 011.517-1.014 4.632 4.632 0 011.793-.357h.584c.165 0 .303.056.415.168.112.112.168.25.168.415v.584c0 .622-.12 1.22-.357 1.793a4.641 4.641 0 01-4.31 2.873v2.334c0 .165-.056.303-.167.415s-.25.168-.416.168z",
    fill: "#000"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--plant-c011c4d22385b7e0f436a2f49b74312b.svg";
export { SvgIconCirclePlant as Component };